import React from 'react'
import Header from '../components/Header'
import { SingleVedio } from '../components/SingleVedio'

export const Singlepage = () => {
  return (
      <>
        <Header/>
        <SingleVedio/>
    </>
  )
}
